
  import { css } from 'lit';
export default css`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
/* Apply proper CSS for accessibly hiding elements to each component. */
.visually-hidden {
  position: absolute !important;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border-width: 0;
}
/* Apply component specific CSS */
:host {

    display: block;
}

.links {

    padding-top: 1rem;

    padding-bottom: 1rem;
}

@media (min-width: 768px) {

    .links {

        background-color: var(--neutral-gray-5);
    }

    .links {

        padding-top: 0px;

        padding-bottom: 0px;
    }
}

ul {

    margin: 0px;

    display: flex;

    list-style-type: none;

    flex-direction: column;

    flex-wrap: wrap;

    border-width: 0px;

    border-left-width: 1px;

    border-right-width: 1px;

    border-top-width: 1px;

    border-style: solid;

    border-color: var(--neutral-gray-4);

    padding: 0px;
}

@media (min-width: 768px) {

    ul {

        flex-direction: row;
    }

    ul {

        border-width: 0px;
    }
}

ul li {

    margin: 0px;
}

ul li {

    display: flex;
}

ul li {

    border-width: 0px;
}

ul li {

    border-bottom-width: 1px;
}

ul li {

    border-style: solid;
}

ul li {

    border-color: var(--neutral-gray-4);
}

ul li {

    padding: 0px;
}

@media (min-width: 768px) {

    ul li {

        border-width: 0px;
    }
}

a {

    flex-grow: 1;

    background-color: var(--neutral-gray-5);

    padding-top: 1rem;

    padding-bottom: 1rem;

    padding-left: 1.5rem;

    padding-right: 1.5rem;

    font-weight: var(--fw-medium);

    color: var(--neutral-black);

    text-decoration-line: none;
}

a:hover {

    background-color: var(--neutral-gray-4);
}

a.is-active {

    background-color: var(--primary-blue-dark);
}

a.is-active {

    color: var(--neutral-white);
}

.tabs__trigger {

    display: block;

    cursor: pointer;

    border-width: 0px;

    border-left-width: 1px;

    border-style: solid;

    background-color: var(--neutral-white);

    padding-left: 1rem;

    padding-right: 1rem;
}

@media (min-width: 768px) {

    .tabs__trigger {

        display: none;
    }
}

li.is-active {

    order: -9999;
}

@media (min-width: 768px) {

    li.is-active {

        order: 0;
    }
}

li:not(.is-active) {

    display: none;
}

@media (min-width: 768px) {

    li:not(.is-active) {

        display: flex;
    }
}

.is-open li {

    display: flex;
}
`;